import { getIncomeById } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useMerchantPosContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/_shared/contexts/MerchantPosContext';
import { BorrowerOnboardingDetailsMap } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/BorrowerOnboardingDetailsForm/maps/borrowerOnboardingDetails.map';
import { MERCHANT_POS_DEFAULT_VALUES } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/constants/MerchantPosDefaultValues';
import { developOptions } from '@/config/developOptions';

export const useMerchantPosDefaultValues = () => {
  const { selectedRole, paymentMethodDetailEntity, borrowerOnboardingDetails } = useMerchantPosContext();

  const [defaultValues, setDefaultValues] = useState<BorrowerOnboardingDetailsMap | undefined>(undefined);

  const getDefaultValues = async () => {
    if (!selectedRole) {
      return;
    }

    // If borrowerOnboardingDetails are passed, we use them to populate the form
    if (borrowerOnboardingDetails.length > 0) {
      const onboardingDetails = borrowerOnboardingDetails.find((p) => p.role === selectedRole);
      if (onboardingDetails && onboardingDetails.userDetails) {
        setDefaultValues(BorrowerOnboardingDetailsMap.fromStoredToForm(onboardingDetails));
        return;
      }
    }

    // If not, we use the paymentMethodDetailEntity to populate the form
    if (paymentMethodDetailEntity.hasOnboardingDetails(selectedRole)) {
      const loan = paymentMethodDetailEntity.loan;
      const onboardingDetails = paymentMethodDetailEntity.onboardingDetails(selectedRole);

      if (loan && onboardingDetails && onboardingDetails.userDetails) {
        const income = await getIncomeById({
          loanId: loan.id,
          onboardingDetailsId: onboardingDetails.id,
        });
        setDefaultValues(
          BorrowerOnboardingDetailsMap.fromLoanOnboardingDetailsToForm(
            onboardingDetails,
            income,
            loan.borrowerCashInCashOutMethodAccountNumber,
          )!,
        );
        return;
      }
    }

    // Last, if borrower and customer is set, we return a blank form with customer data
    const customer = paymentMethodDetailEntity.checkoutSession.customer;
    const blankForm = BorrowerOnboardingDetailsMap.getBlankForm(customer);

    // if (customer && selectedRole === OnboardingDetailsRole.BORROWER) {
    //   setDefaultValues(BorrowerOnboardingDetailsFormMap.getBlankForm(customer));
    //   return;
    // }

    if (developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES) {
      const defaultValues = {
        ...MERCHANT_POS_DEFAULT_VALUES[selectedRole],
        ...(blankForm.firstName !== '' && { firstName: blankForm.firstName }),
        ...(blankForm.lastName !== '' && { lastName: blankForm.lastName }),
        ...(blankForm.documentNumber !== '' && { documentNumber: blankForm.documentNumber }),
        ...(blankForm.email !== '' && { email: blankForm.email }),
        ...(blankForm.phoneNumber !== '' && { phoneNumber: blankForm.phoneNumber }),
        ...(blankForm.phoneNumber !== '' && { dialCode: blankForm.dialCode }),
      };
      setDefaultValues(defaultValues);
      return;
    }

    setDefaultValues(blankForm);
  };

  return {
    defaultValues,
    getDefaultValues,
  };
};
